import Vue from 'vue'
import Vuex from 'vuex'
import {envs} from './All.env'

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        API_ENDPOINT:  envs[process.env.NODE_ENV||'development'].API_ENDPOINT,
        Client_ID: envs[process.env.NODE_ENV||'development'].Client_ID,
        user: {},
        ACCOUNT_TABS_LOGIN:'Sign in to your account',
        ACCOUNT_TABS_SIGNUP:"Create a new account",
    }
});


// WEBPACK FOOTER //
// ./src/store/index.js